import api from "@/apis/AuditingLogAPI";
import Crud from "./crud-base";
var crud = new Crud("AuditingLog", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AuditingLogID",
      name: "Description",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
